import _ from 'lodash';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import SeasonSections from './SeasonSections';

const CreateSportSeasonAlignment = () => {

  const hasDynamicKey = (obj, key) => {
    return _.some(obj, (value, objKey) =>
      objKey === key || (_.isPlainObject(value) && hasDynamicKey(value, key))
    );
  };

  const getParentKeysForKey = (obj, key, parentKeys = []) => {
    // Iterate through the object's keys and values
    return _.some(obj, (value, objKey) => {
      if (objKey === key) {
        // Match found, return the current path
        parentKeys.push(objKey);
        return true;
      } else if (_.isPlainObject(value)) {
        // Continue searching in nested objects
        const found = getParentKeysForKey(value, key, [...parentKeys, objKey]);
        if (found) {
          parentKeys.push(objKey);
          return true;
        }
      }
      return false;
    }) && parentKeys.reverse(); // Reverse to preserve parent-to-child order
  };

  const content_sections = () => <Wrapper
    header={'Sections'}
    content={<SeasonSections />}
    wrapperType={wrapperTypes.padded}
  />

  return content_sections()

}

export default CreateSportSeasonAlignment